import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CommentsSummaryToSubmitModal from '../CommentsSummaryToSubmitModal';
import CommentsSubmitAllButton from '../CommentsSubmitAllButton';
import * as Selectors from '../../selectors';

export const CommentsButton = ({ shouldShowCommentsSummaryToSubmitModal, isDisplay }) => {
    if (!isDisplay) { return null; }

    return (
        shouldShowCommentsSummaryToSubmitModal
            ? <CommentsSummaryToSubmitModal/>
            : <CommentsSubmitAllButton/>
    );
};

CommentsButton.propTypes = {
    shouldShowCommentsSummaryToSubmitModal: PropTypes.bool,
    isDisplay: PropTypes.bool
};

CommentsButton.defaultProps = {
    shouldShowCommentsSummaryToSubmitModal: false,
    isDisplay: true
};

const mapStateToProps = (state) => ({
    shouldShowCommentsSummaryToSubmitModal: Selectors.isSellerGroupInRevisionMode(state)
});

export default connect(mapStateToProps)(CommentsButton);
